import {loginActionTypes} from './login.actionTypes';
const initialState = {
  //ld - loading
  //er - error in action
  ld_registerUser: false,
  er_registerUser: null,
  isRegister_success: false,
  ld_verifyMobile: false,
  verify_mobile: false,
  er_verifyMobile: null,
  ld_verifyOtp: false,
  er_verifyOtp: null,
  verifyOtp_success: false,
  isStoreFirstLogin: false,
  interimRegisterSuccess: {},
  showLoginModal: false,
  isLoggingIn: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case loginActionTypes.REGISTER_USER_LOAD: {
      return {...state, ld_registerUser: true};
    }
    case loginActionTypes.IS_LOGGING_IN: {
      return {...state, isLoggingIn: action.payload};
    }
    case loginActionTypes.REGISTER_USER: {
      return {
        ...state,
        ld_registerUser: false,
        isRegister_success: action.payload?.success,
        interimRegisterSuccess: action.payload,
        er_registerUser: null,
      };
    }
    case loginActionTypes.REGISTER_USER_FAIL: {
      return {
        ...state,
        ld_registerUser: false,
        er_registerUser: action.error,
      };
    }
    case loginActionTypes.REGISTER_USER_MODAL_CLOSE: {
      return {
        ...state,
        isRegister_success: false,
        interimRegisterSuccess: {},
      };
    }
    case loginActionTypes.VERIFY_OTP_LOAD: {
      return {...state, ld_verifyOtp: true};
    }
    case loginActionTypes.VERIFY_OTP: {
      return {
        ...state,
        ld_verifyOtp: false,
        verifyOtp_success: action.payload,
        er_verifyOtp: null,
      };
    }
    case loginActionTypes.VERIFY_OTP_ERROR: {
      return {...state, ld_verifyOtp: false, er_verifyOtp: action.error};
    }
    case loginActionTypes.VERIFY_MOBILE_LOAD: {
      return {...state, ld_verifyMobile: true};
    }
    case loginActionTypes.VERIFY_MOBILE_SUCCESS: {
      return {
        ...state,
        ld_verifyMobile: false,
        verify_mobile: action.payload?.success,
        er_verifyMobile: null,
      };
    }
    case loginActionTypes.VERIFY_MOBILE_FAIL: {
      return {
        ...state,
        ld_verifyMobile: false,
        er_verifyMobile: action.error,
      };
    }
    case loginActionTypes.CHECK_FIRST_LOGIN: {
      return {
        ...state,
        isStoreFirstLogin: action.payload,
      };
    }
    case loginActionTypes.SHOW_LOGIN_MODAL:
      return {
        ...state,
        showLoginModal: action.payload,
      };
    default: {
      return state;
    }
  }
};

export {reducer as loginReducer};
